var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"bid-mirror"},[_c('content-header',{attrs:{"path":"Resultado"}}),_vm._v(" "),_c('event-details-header',{attrs:{"event-id":_vm.eventId}}),_vm._v(" "),_c('section',{staticClass:"main-container row"},[_c('mirror-form',{attrs:{"event-id":_vm.eventId}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-faf9a696","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/bid-mirror/BidMirror.vue
// module id = null
// module chunks = 